// src/config/apiBase.js
const FALLBACK = "https://api.psyassist.com.br";
export const API_BASE = String(process.env.REACT_APP_API_URL || FALLBACK).replace(/\/$/, "");
